import React from 'react';
import styles from './Scoreboard.module.css';
import Score from './Score';
import ScoreReduced from './ScoreReduced';

const Scoreboard = (props) => {
    const scoreboard = props.teams.map((t, index) => {
        const plays = props.teamPlays === index;

        let score = null;
        if(props.windowWidth > 600) {
            score = <Score key={t.id} team={t} plays={plays} />;
        }
        else {
            score = <ScoreReduced key={t.id} team={t} plays={plays} numberOfTeams={props.teams.length}/>
        }

        return score;
    });
    return <div className={styles.scoreboard}>{scoreboard}</div>;
}
export default Scoreboard;